export default "__VITE_ASSET__Bd7dIxYV__"